const SelectPropertyConstants = {
  APPLICATIONS: 'applications',
  LEASES: 'leases',
  LISTINGS: 'listings',
  PAYMENTS: 'payments',
  RENTAL_PROTECTION: 'rental-protection',
} as const;

const SelectPropertyDispatchConstants = {
  [SelectPropertyConstants.APPLICATIONS]: SelectPropertyConstants.APPLICATIONS,
  [SelectPropertyConstants.LEASES]: SelectPropertyConstants.LEASES,
  [SelectPropertyConstants.LISTINGS]: SelectPropertyConstants.LISTINGS,
  [SelectPropertyConstants.PAYMENTS]: SelectPropertyConstants.PAYMENTS,
  [SelectPropertyConstants.RENTAL_PROTECTION]: 'rentalProtection',
} as const;

export { SelectPropertyDispatchConstants };
export default SelectPropertyConstants;
